import { __rest } from "tslib";
import React from 'react';
import { HeaderCell } from '../styled';
import { SkeletonContent } from '../SkeletonContent';
export const SkeletonHeaderCell = (_a) => {
    var { style, width, isLoading } = _a, otherProps = __rest(_a, ["style", "width", "isLoading"]);
    return (React.createElement(HeaderCell, Object.assign({}, otherProps, { style: { width } }),
        React.createElement(SkeletonContent, { style: style, isLoading: isLoading })));
};
//# sourceMappingURL=SkeletonHeaderCell.js.map